import { TranslationKey } from './../../../types/translation/TranslationKey';
import React, { useContext } from 'react';
import { t } from '../../../types/translation/Translator';
import Pane from '../../../VentoryUI/components/common/Pane';
import { Navigate, Route, Routes } from 'react-router-dom';
import UserAssetOverviewPane from './Panes/UserAssetOverviewPane';
import UserAssetPendingPane from './Panes/UserAssetPendingPane';
import {
  AssetTransaction,
  AssetTransactionParentType,
  AssetTransactionStatus,
  AssetTransactionType,
} from '../../../types/asset_transaction/assetTransaction';
import { AssetTransactionContext } from '../../../context/AssetTransactionContext';
import { User } from '../../../types/user/user';
import { UserContext } from '../../../context/UserContext';
import { Company } from '../../../types/company';
import { CompanyContext } from '../../../context/CompanyContext';
import UserAssetHistoryPane from './Panes/UserAssetHistoryPane';

const tabs = (user: User | null | undefined, transactions: Map<string, AssetTransaction>, company: Company) => {
  const hasOpen = new Set(
    [...transactions.values()]
      .filter(
        transaction =>
          transaction.parentType === AssetTransactionParentType.reassign &&
          transaction.type === AssetTransactionType.outbound &&
          transaction.status === AssetTransactionStatus.pending,
      )
      .map(transaction => transaction.parentId),
  );

  const pending = [...transactions.values()].filter(
    transaction =>
      user?.id &&
      transaction.location?.entityId === user.id &&
      ((transaction.status === AssetTransactionStatus.pending &&
        (transaction.type === AssetTransactionType.outbound || !hasOpen.has(transaction.parentId))) ||
        (transaction.type === AssetTransactionType.verify && transaction.status === AssetTransactionStatus.created)),
  ).length;

  return [
    {
      text: t(TranslationKey.asset).plural.label,
      path: 'info',
      key: 'info',
    },
    {
      text: (
        <span className='flex items-center gap-2'>
          <p>{t(TranslationKey.pending).singular.label}</p>
          {pending ? (
            <span className='flex size-4 items-center justify-center rounded-full bg-primary text-xs text-on-primary'>
              {pending > 9 ? '9+' : pending}
            </span>
          ) : null}
        </span>
      ),
      path: 'pending',
      key: 'pending',
      disabled: !pending,
    },
    {
      text: t(TranslationKey.history).singular.label,
      path: 'history',
      key: 'history',
    },
  ];
};

export default function UserAssetScreen() {
  const { assetTransactions } = useContext(AssetTransactionContext);
  const { currentUser } = useContext(UserContext);
  const { currentCompany } = useContext(CompanyContext);

  return (
    <Pane tabs={tabs(currentUser, assetTransactions, currentCompany)}>
      <Routes>
        <Route path='*' element={<Navigate to={'info'} />} />
        <Route path='/info/*' element={<UserAssetOverviewPane />} />
        <Route path='/pending/*' element={<UserAssetPendingPane />} />
        <Route path='/history/*' element={<UserAssetHistoryPane />} />
      </Routes>
    </Pane>
  );
}
